import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.accordion.background};
  border-radius: 8px;

  ${props => props.isDisabled && 'pointer-events: none;'}
`;

export const Title = styled.h3`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 600;
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(20)};
  color: ${props => props.theme.accordion.title};
`;

export const IconWrapper = styled.div`
  width: 28px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.theme.space(3)};
  cursor: pointer;

  .chevron {
    transition: transform 0.25s ease;

    path {
      stroke: ${props => props.theme.accordion.chevron};
    }
  }

  .open {
    transform: rotate(-180deg);
  }
`;

export const Content = styled.div`
  padding: 0 ${props => props.theme.space(3)};
  width: 90%;
  overflow: hidden;
  max-height: 0;
  transition: all 0.3s ease-in-out;
  margin-left: ${props => (props.hasIcon ? props.theme.space(11) : 0)};

  &.open {
    max-height: unset;
    padding-bottom: ${props => props.theme.space(3)};
  }
`;

export const Text = styled.span`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(20)};
  color: ${props => props.theme.accordion.text};

  a {
    margin-left: ${props => props.theme.space(1)};
    font-size: ${props => props.theme.rem(14)};
    color: ${props => props.theme.accordion.urlText};
    -webkit-text-decoration: none;
    text-decoration: none;
  }
`;
